import React from "react";
import ServicesContactForm from "../components/ServicesContactForm";

const Consultation = () => {
  return (
    <section className="w-full min-h-screen bg-primario p-5 md:p-20 ">
      <h1 className="text-4xl sm:text-6xl md:text-7xl font-bold font-primaria mx-auto  md:max-w-6xl text-secundario mb-10">
        Book a consultation
      </h1>
      <ServicesContactForm />
    </section>
  );
};

export default Consultation;
